module.exports = __webpack_public_path__ + "img/goa.276b4d80.png";